import { render } from "./DateManipulation.vue?vue&type=template&id=63cf99f2"
import script from "./DateManipulation.vue?vue&type=script&lang=js"
export * from "./DateManipulation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__